import EditDriverView from "features/Fleet/FleetDriver/components/EditDriverView";
import useRouter from "hooks/useRouter";

EditChargeDriverScreen.propTypes = {};

function EditChargeDriverScreen(props) {
    // MARK: ---- PROPERTIES ----
    const router = useRouter();
    const driverId = router.query?.chargeDriverId;

    return (
        <div>
            <div className="my-4">
                <EditDriverView isAddCustomer={true} driverId={driverId} />
            </div>
        </div>
    );
}

export default EditChargeDriverScreen;
